import { Component, effect, untracked } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatRadioButton, MatRadioChange, MatRadioGroup } from '@angular/material/radio';

import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CipoControlBase } from '@shared/components/fields/cipo-control.base';
import { CipoListConfig } from '@shared/components/fields/common';
import { CipoFormModule } from '@shared/modules/forms.module';
import { CipoOutlineFieldComponent } from '../cipo-outline-field/cipo-outline-field.component';
import { CipoTextViewComponent } from '../cipo-text-view/cipo-text-view.component';

@Component({
  selector: 'cipo-radio-group',
  templateUrl: './cipo-radio-group.component.html',
  imports: [
    CipoFormModule,
    CipoTextViewComponent,
    MatRadioButton,
    MatRadioGroup,
    FlexLayoutModule,
    CipoOutlineFieldComponent,
  ],
  styles: [
    `
      :host {
        max-height: inherit;
      }
    `,
  ],
})
export class CipoRadioGroupComponent extends CipoControlBase<string | string[], CipoListConfig> {
  constructor() {
    super();
    effect(() => {
      const dataSourceInfo = untracked(() => this.fieldData().dataSourceInfo);
      if (!this.deepFieldData.readonly() && dataSourceInfo) {
        untracked(() => this.loadDataSource(dataSourceInfo));
      }
    });
  }

  isOptionSelected(key: any): boolean {
    const value = this.control().value;
    if (Array.isArray(value)) {
      return value.includes(key);
    }
    return value === key;
  }

  radioChange(event: MatRadioChange) {
    this.control().setValue(event.value);
    this.control().markAsDirty();
    this.control().markAsTouched();
  }

  checkboxChange(event: MatCheckboxChange, key: any) {
    const currentVal = (this.control().value as string[]) || [];
    let newVal: string[];

    if (event.checked) {
      newVal = [...currentVal, key];
    } else {
      newVal = currentVal.filter(v => v !== key);
    }

    this.control().setValue(newVal);
    this.control().markAsDirty();
    this.control().markAsTouched();
  }
}
